import * as React from 'react';

import FolderShared32 from './FolderShared32';

export const folderShared32 = () => <FolderShared32 />;

export default {
    title: 'Icon|Content|FolderShared32',
    component: FolderShared32,
    parameters: {
        notes: "`import FolderShared32 from 'box-ui-elements/es/icon/content/FolderShared32';`",
    },
};
